import { useState, type FC } from 'react';
import { useIntl } from 'react-intl';
import { messages } from '../localization/messages.ts';

export interface AgentLogo {
  src: string;
  alt: string;
}

/** Optional brand mark in the response scroller. Missing or failed assets leave no header. */
export const StageHeader: FC<{
  logo?: AgentLogo;
  onRestart: (intent: string) => void;
  disabled?: boolean;
}> = ({ logo, onRestart, disabled = false }) => {
  const intl = useIntl();
  const [failedSrc, setFailedSrc] = useState<string>();
  if (!logo?.src || logo.src === failedSrc) {
    return null;
  }

  return (
    <header className="stage-header flex justify-center pb-6 pt-logo-inset">
      <button
        type="button"
        aria-label={intl.formatMessage(messages.brandStartOver, { brandName: logo.alt })}
        disabled={disabled}
        onClick={() => onRestart(intl.formatMessage(messages.startOver))}
        className="flex h-20 w-20 items-center justify-center overflow-hidden rounded-full border border-border bg-card p-3 transition-colors hover:border-primary hover:bg-muted focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:cursor-wait disabled:opacity-60"
      >
        <img
          key={logo.src}
          src={logo.src}
          alt={logo.alt}
          width={64}
          height={64}
          className="h-full w-full object-contain"
          onError={() => setFailedSrc(logo.src)}
        />
      </button>
    </header>
  );
};
